import { cn } from 'src/lib/utils';

type Props = {
  title: string;
  description: string;
  action: React.ReactNode;
  variant?: 'primary' | 'secondary';
};

const CallToActionBanner = ({ title, description, action, variant = 'primary' }: Props) => {
  return (
    <div
      className={cn('flex flex-col sm:items-center sm:flex-row p-4 rounded-lg gap-3', {
        'bg-secondary-foreground': variant === 'primary',
        'bg-card border border-border': variant === 'secondary',
      })}
    >
      <div className="grow space-y-1 text-sm">
        <h6
          className={cn('font-bold', {
            'text-base text-white': variant === 'primary',
            'font-bold text-foreground': variant === 'secondary',
          })}
        >
          {title}
        </h6>
        <p
          className={cn({
            'text-white/70': variant === 'primary',
            'text-muted-foreground': variant === 'secondary',
          })}
        >
          {description}
        </p>
      </div>
      <div className="shrink-0 *:w-full sm:*:w-auto">{action}</div>
    </div>
  );
};

export default CallToActionBanner;
